import Jeffrey from './Jeffrey.png';
import Bert from './Bert.png';

export const PERSON_IMAGES = {
  Jeffrey,
  Bert,
};
